// src/services/authService.js
import api from "@/services/api";
import { toast } from "vue3-toastify";

export const authService = {
  signIn(data) {
    return api.post("/login", data).catch(handleError);
  },
};

// Função para tratamento de erro
const handleError = (error) => {
  toast.error(error.response.data.message, {
    position: toast.POSITION.BOTTOM_RIGHT,
    theme: toast.THEME.COLORED,
    className: "foo-bar",
  });
  throw error;
};

export default authService;
